/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { MdArrowOutward } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks/hooks";
import { ColorsEnum } from "../../shared/constants/enums/Colors";
import StyledLink from "../styled/Link/Link";
import { createNamedStyles } from "../../shared/CreateNamedStyles";

interface StyledLinkProps {
  iconElement?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  url: string;
  label: string;
  children?: ReactNode;
}

export const StyleLinkElement = ({
  iconElement,
  label,
  url,
  children,
}: StyledLinkProps): JSX.Element => {
  const location = useLocation();
  const isActive = location.pathname.includes(url);
  const isSidebarOpen = useAppSelector((state) => state.app.isSidebarDocsOpen);
  const isExternal = url.includes("https://");

  const Icon = iconElement;
  return (
    <StyledLink
      toUrl={url}
      className="sidebarLink"
      sx={{ display: "block !important" }}
    >
      <ListItem disablePadding sx={{ display: "block", width: "300px" }}>
        <ListItemButton
          tabIndex={-1}
          sx={{
            minHeight: "48px",
            backgroundColor: ColorsEnum["#0A0A0A"],
            "&:hover": {
              "& .MuiListItemText-root .MuiTypography-root": {
                color: ColorsEnum["#FCFCFC"],
              },
              "& .MuiListItemIcon-root path": {
                fill: ColorsEnum["#D53235"],
              },
            },
          }}
        >
          {Icon && (
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: isSidebarOpen ? 2 : "auto",
                justifyContent: "center",
                "& path": {
                  fill: isActive ? ColorsEnum["#D53235"] : "#737373",
                },
              }}
            >
              <Icon
                style={{
                  width: 16,
                  height: 16,
                  marginBottom: "2px",
                }}
              />
            </ListItemIcon>
          )}
          <ListItemText
            primary={label}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "16px",
                color: ColorsEnum["#C7C7C7"],
                fontWeight: isActive ? 800 : 500,
              },
              opacity: isSidebarOpen ? 1 : 0,
            }}
          />
          {isExternal && isSidebarOpen && (
            <MdArrowOutward size={16} style={{ color: "#575757" }} />
          )}
        </ListItemButton>
      </ListItem>
      {children}
    </StyledLink>
  );
};

export const SideBarDocsStyles = createNamedStyles({
  menu: {
    paddingTop: "0 !important",
  },
  accordionSummary: {
    ".Mui-expanded": {
      margin: "0 !important",
    },
    margin: "0 !important",
    padding: 0,
    minHeight: "48px !important",
  },
  accordion: {
    margin: "0 !important",
    padding: 0,
  },
});

export const SideBarDocsIStyles = (
  element: string,
  isActive?: boolean,
  isOpen?: boolean
) => {
  const SideBarStyles: { [key: string]: any } = {
    title: {
      fontWeight: isActive ? 800 : 500,
      color: ColorsEnum["#C7C7C7"],
      display: "flex",
    },
    box: {
      width: isOpen ? "330px" : "0",
      zIndex: 20,
      "& .MuiPaper-root": {
        backgroundColor: ColorsEnum["#0A0A0A"],
        paddingLeft: "0",
        "& div": {
          backgroundColor: ColorsEnum["#0A0A0A"],
        },
      },
    },
  };

  return SideBarStyles[element];
};
